<template>
	<frontend-layout>
		<Head>
			<title>
				{{
					$i18n.locale == "zh-TW" ? document_title : document_title_en
				}}
				- {{ $t("document") }} - {{ $t("siteTitle") }}
			</title>
		</Head>
		<template #header>
			<div class="annoucement">
				<h1>{{ $t("docs.document") }}</h1>
			</div>
		</template>

		<template #breadcrumb>
			<div class="pageInfo mb-2 p-1">
				<div class="page-breadcrumb float-sm-right">
					<ol class="breadcrumb">
						<li class="breadcrumb-item">
							<InertiaLink
								:href="'/'"
								:class="{
									active: $page.url === '/',
								}">
								{{ $t("home") }}
							</InertiaLink>
						</li>
						<li class="breadcrumb-item">
							<InertiaLink
								:href="'/docs'"
								:class="{
									active: $page.url === '/docs',
								}">
								{{ $t("document") }}
							</InertiaLink>
						</li>
						<li
							v-if="$i18n.locale == 'zh-TW'"
							class="breadcrumb-item">
							{{ document_title }}
						</li>
						<li v-else class="breadcrumb-item">
							{{ document_title_en }}
						</li>
					</ol>
				</div>
			</div>
		</template>

		<section>
			<div class="content-box ck-content" v-if="document_title">
				<h2 v-if="$i18n.locale == 'zh-TW'">{{ document_title }}</h2>
				<h2 v-else>{{ document_title_en }}</h2>

				<p class="subtitle">
					{{ $t("docs.createdDate") }}:&nbsp;{{ created_at }}
				</p>
				<hr />
				<p
					v-if="$i18n.locale == 'zh-TW'"
					v-html="document_introduction"></p>
				<p v-else v-html="document_introduction_en"></p>
				<div v-if="attachments.length != 0">
					<hr />
					<h5>{{ $t("docs.attachments") }}</h5>
					<a
						v-for="data in attachments"
						:key="data.document_attachment_id"
						class="attachment"
						:href="data.path"
						target="_blank">
						<span class="ts-icon is-download-icon"></span>
						&nbsp;&nbsp;{{ data.file_title }}
					</a>
				</div>
				<hr v-else />
				<div class="subdetail">
					{{ $t("docs.lastUpdate") }}:&nbsp;{{
						updated_at
					}}&nbsp;&nbsp;&nbsp;
				</div>
			</div>
			<div class="box-bottom">
				<div class="box-bottom-item">&nbsp;</div>
				<div class="box-bottom-item pad">&nbsp;</div>
				<InertiaLink class="box-bottom-item middle" href="/docs/">{{
					$t("docs.backList")
				}}</InertiaLink>
				<div class="box-bottom-item pad">&nbsp;</div>
				<div class="box-bottom-item next">&nbsp;</div>
			</div>
		</section>
	</frontend-layout>
</template>

<script>
// import moment from 'moment';
import FrontendLayout from "@/Frontend/Shared/Layout";
import hljs from "highlight.js/lib/core";
import bash from "highlight.js/lib/languages/bash";

hljs.registerLanguage("bash", bash);

export default {
	// Using the shorthand
	components: { FrontendLayout, hljs },
	data() {
		return {
			csrf: document
				.querySelector('meta[name="csrf-token"]')
				.getAttribute("content"),
			primary_category_id: this.$props.primary_category_id,
			primary_category_title: this.$props.primary_category_title,
			primary_category_title_en: this.$props.primary_category_title_en,
			document_introduction: this.$props.document_introduction,
			document_introduction_en: this.$props.document_introduction_en,
			document_title: this.$props.document_title,
			document_title_en: this.$props.document_title_en,
			hasAttachment: this.$props.hasAttachment,
			attachments: this.$props.attachments,
			updated_at: this.$props.updated_at,
			created_at: this.$props.created_at,
		};
	},
	props: {
		primary_category_id: Number,
		primary_category_title: String,
		primary_category_title_en: String,
		document_introduction: String,
		document_introduction_en: String,
		document_title: String,
		document_title_en: String,
		hasAttachment: Boolean,
		attachments: Array,
		updated_at: String,
		created_at: String,
	},
	methods: {},
	created: function () {},
};
</script>

<style scoped>
figure table {
	background-color: red;
}
figure.table table {
	width: 100%;
	padding: 1rem;
	border-radius: 1rem;
	border: 1px solid black;
}
figure table tr {
	line-height: 1.5rem;
}
.announcement {
	text-align: center;
}
.content-box {
	position: relative;
	margin-left: auto;
	margin-right: auto;
	max-width: 950px;
	min-width: 360px;
	width: 70%;
	background-color: #ffff;
	padding: 45px 45px 20px 45px;
	box-shadow: #9d9d9d 0px 0px 7px 0px;
	border-radius: 1px;
	margin-bottom: 10px;
}

.content-box h2 {
	font-family: "Poppins", sans-serif;
	margin-bottom: 18px;
	color: #3e3f47;
}

.content-box h5 {
	color: #3e3f47;
	font-family: "Poppins", sans-serif;
}
.subtitle {
	color: grey;
	line-height: 0px;
}
.subdetail {
	width: 100%;
	color: grey;
	line-height: 0px;
	text-align: right;
}
.attachment {
	text-decoration: none;
	display: block;
	color: #3d4a63;
}
.attachment:hover {
	color: #0a7a7f;
}
.box-bottom {
	position: relative;
	margin-left: auto;
	margin-right: auto;
	max-width: 950px;
	width: 70%;
	margin-bottom: 10rem;
}

.box-bottom-item {
	display: inline-block;
	text-decoration: none;
	width: 8%;
	color: grey;
}

.middle {
	text-align: center;
}
.pad {
	width: 38%;
}

.next {
	text-align: right;
}
</style>
